<template>
	<sf-modal-layout size="xl" :title="getMessage_('SWCC000253')" :show="show_" :closeModal="closeModal">
		<!-- Plant Start -->
		<el-row :gutter="30">
			<el-col :span="8">
				<sf-select-group
					:label="getMessage_('SWCC000247')"
					:labelSpan="10"
					labelPosition="left"
					:inputValue="selectedRow.plantCd"
					:options="plants_"
					:onChange="value => onChange({ key: 'plantCd', value })"
				/>
			</el-col>
		</el-row>
		<!-- Plant End -->

		<!-- Shop & Line Start -->
		<el-row :gutter="30">
			<el-col :span="8">
				<sf-select-group
					:label="getMessage_('SWCC000248')"
					:labelSpan="10"
					labelPosition="left"
					:inputValue="selectedRow.shopCd"
					:options="shopCds_.filter(option => option.label !== 'ALL')"
					:onChange="value => onChange({ key: 'shopCd', value })"
					:disabled="disabled"
				/>
			</el-col>
			<el-col :span="8">
				<sf-select-group
					:label="getMessage_('SWCC000254')"
					:labelSpan="10"
					labelPosition="left"
					:inputValue="selectedRow.lineCd"
					:options="lines_"
					:onChange="value => onChange({ key: 'lineCd', value })"
					:disabled="disabled"
				/>
			</el-col>
		</el-row>

		<!-- Shop & Line Start End -->

		<!-- Program ID & Program Name Start -->
		<el-row :gutter="30">
			<el-col :span="8">
				<sf-input-group
					:label="getMessage_('SWCC000255')"
					:labelSpan="10"
					labelPosition="left"
					:inputValue="selectedRow.pgmId"
					:onChange="value => onChange({ key: 'pgmId', value })"
					:disabled="disabled"
				/>
			</el-col>
			<el-col :span="8">
				<sf-input-group
					:label="getMessage_('SWCC000256')"
					:labelSpan="10"
					labelPosition="left"
					:inputValue="selectedRow.pgmName"
					:onChange="value => onChange({ key: 'pgmName', value })"
				/>
			</el-col>
			<el-col :span="8">
				<sf-input-group
					:label="getMessage_('SWCC000945')"
					:labelSpan="10"
					labelPosition="left"
					:inputValue="selectedRow.pgmUrl"
					:onChange="value => onChange({ key: 'pgmUrl', value })"
				/>
			</el-col>
		</el-row>
		<!-- Program ID & Program Name End -->

		<!-- Service & Program Type & Main Flag Start -->
		<el-row :gutter="30">
			<el-col :span="8">
				<sf-select-group
					:label="getMessage_('SWCC000250')"
					:labelSpan="10"
					labelPosition="left"
					:inputValue="selectedRow.serviceKind"
					:options="serviceKinds_.filter(option => option.label !== 'ALL')"
					:onChange="value => onChange({ key: 'serviceKind', value })"
				/>
			</el-col>
			<el-col :span="8">
				<sf-select-group
					:label="getMessage_('SWCC000251')"
					:labelSpan="10"
					labelPosition="left"
					:inputValue="selectedRow.pgmType"
					:options="pgmTypes_.filter(option => option.label !== 'ALL')"
					:onChange="value => onChange({ key: 'pgmType', value })"
				/>
			</el-col>
			<el-col :span="8">
				<sf-select-group
					:label="getMessage_('SWCC000257')"
					:labelSpan="10"
					labelPosition="left"
					:inputValue="selectedRow.mainFlg"
					:options="mainFlgs_"
					:onChange="value => onChange({ key: 'mainFlg', value })"
				/>
			</el-col>
		</el-row>
		<!-- Service & Program Type & Main Flag End -->

		<!-- Exe Env & Server Name & Exe File Start -->
		<el-row :gutter="30">
			<el-col :span="8">
				<sf-select-group
					:label="getMessage_('SWCC000258')"
					:labelSpan="10"
					labelPosition="left"
					:inputValue="selectedRow.exeEnv"
					:options="exeEnvs_"
					:onChange="value => onChange({ key: 'exeEnv', value })"
				/>
			</el-col>
			<el-col :span="8">
				<sf-select-group
					:label="getMessage_('SWCC000259')"
					:labelSpan="10"
					labelPosition="left"
					:inputValue="selectedRow.serverName"
					:options="serverNames_.filter(option => option.label !== 'ALL')"
					:onChange="value => onChange({ key: 'serverName', value })"
				/>
			</el-col>
			<el-col :span="8">
				<sf-input-group
					:label="getMessage_('SWCC000260')"
					:labelSpan="10"
					labelPosition="left"
					:inputValue="selectedRow.exeFile"
					:onChange="value => onChange({ key: 'exeFile', value })"
				/>
			</el-col>
		</el-row>
		<!-- Exe Env & Server Name & Exe File End -->

		<!-- Exe Path & Work Path Start -->
		<el-row :gutter="30">
			<el-col :span="8">
				<sf-input-group
					:label="getMessage_('SWCC000261')"
					:labelSpan="10"
					labelPosition="left"
					:inputValue="selectedRow.exePath"
					:onChange="value => onChange({ key: 'exePath', value })"
				/>
			</el-col>
			<el-col :span="8">
				<sf-input-group
					:label="getMessage_('SWCC000262')"
					:labelSpan="10"
					labelPosition="left"
					:inputValue="selectedRow.workPath"
					:onChange="value => onChange({ key: 'workPath', value })"
				/>
			</el-col>
		</el-row>
		<!-- Exe Path & Work Path End -->

		<!-- Socket Server Ip & Socket Server Port Start -->
		<el-row :gutter="30">
			<el-col :span="8">
				<sf-input-group
					:label="getMessage_('SWCC000265')"
					:labelSpan="10"
					labelPosition="left"
					:inputValue="selectedRow.svrIp"
					:onChange="value => onChange({ key: 'svrIp', value })"
				/>
			</el-col>
			<el-col :span="8">
				<sf-input-group
					:label="getMessage_('SWCC000266')"
					:labelSpan="10"
					labelPosition="left"
					:inputValue="selectedRow.svrPort"
					:onChange="value => onChange({ key: 'svrPort', value })"
					:elProps="{ type: 'number' }"
				/>
			</el-col>
		</el-row>
		<!-- Socket Server Ip & Socket Server Port End -->

		<!-- Failover Ip & Failover Port Start -->
		<el-row :gutter="30">
			<el-col :span="8">
				<sf-input-group
					:label="getMessage_('SWCC000267')"
					:labelSpan="10"
					labelPosition="left"
					:inputValue="selectedRow.failOverIp"
					:onChange="value => onChange({ key: 'failOverIp', value })"
				/>
			</el-col>
			<el-col :span="8">
				<sf-input-group
					:label="getMessage_('SWCC000268')"
					:labelSpan="10"
					labelPosition="left"
					:inputValue="selectedRow.failOverPort"
					:onChange="value => onChange({ key: 'failOverPort', value })"
					:elProps="{ type: 'number' }"
				/>
			</el-col>
		</el-row>
		<!-- Failover Ip & Failover Port End -->

		<!-- MonitorCfg Start -->
		<el-row :gutter="30">
			<div class="contour">MonitorCfg</div>
		</el-row>
		<!-- MonitorCfg End -->

		<!-- PLC Off Addr & PLC On Addr Start -->
		<el-row :gutter="30">
			<el-col :span="8">
				<sf-input-group
					:label="getMessage_('SWCC000270')"
					:labelSpan="10"
					labelPosition="left"
					:inputValue="selectedRow.scrOffAddr"
					:onChange="value => onChange({ key: 'scrOffAddr', value })"
				/>
			</el-col>
			<el-col :span="8">
				<sf-input-group
					:label="getMessage_('SWCC000271')"
					:labelSpan="10"
					labelPosition="left"
					:inputValue="selectedRow.scrOnAddr"
					:onChange="value => onChange({ key: 'scrOnAddr', value })"
				/>
			</el-col>
		</el-row>
		<!-- PLC Off Addr & PLC On Addr End -->

		<!-- Screen Save Flg & Screen Qty Start -->
		<el-row :gutter="30">
			<el-col :span="8">
				<sf-group-wrapper class="checkbox-form" :label="getMessage_('SWCC000272')" labelPosition="left" :gutter="30" :labelSpan="20">
					<el-checkbox
						:value="selectedRow.scrSaveFlg === '1'"
						@change="value => onChange({ key: 'scrSaveFlg', value: value ? '1' : '0' })"
					/>
				</sf-group-wrapper>
			</el-col>
			<el-col :span="8">
				<sf-input-group
					:label="getMessage_('SWCC000273')"
					:labelSpan="10"
					labelPosition="left"
					:inputValue="selectedRow.scrQty"
					:onChange="value => onChange({ key: 'scrQty', value })"
					:elProps="{ type: 'number' }"
				/>
			</el-col>
		</el-row>
		<!-- Screen Save Flg & Screen Qty End -->

		<!-- WorkCloseAlert Start -->
		<el-row :gutter="30">
			<el-col :span="8">
				<sf-group-wrapper class="checkbox-form" :label="getMessage_('SWCC000274')" labelPosition="left" :gutter="30" :labelSpan="20">
					<el-checkbox
						:value="selectedRow.workCloseAlertUseYn === '1'"
						@change="value => onChange({ key: 'workCloseAlertUseYn', value: value ? '1' : '0' })"
					/>
				</sf-group-wrapper>
			</el-col>
		</el-row>
		<!-- WorkCloseAlert End -->

		<!-- WorkAbnAlertUse Start -->
		<el-row :gutter="30">
			<el-col :span="8">
				<sf-group-wrapper class="checkbox-form" :label="getMessage_('SWCC000275')" labelPosition="left" :gutter="30" :labelSpan="20">
					<el-checkbox
						:value="selectedRow.workAbnorAlertUseYn === '1'"
						@change="value => onChange({ key: 'workAbnorAlertUseYn', value: value ? '1' : '0' })"
					/>
				</sf-group-wrapper>
			</el-col>
		</el-row>
		<!-- WorkAbnAlertUse End -->

		<!-- MonitorCfg Start -->
		<el-row :gutter="30">
			<div class="contour">WOMCfg</div>
		</el-row>
		<!-- MonitorCfg End -->

		<!-- WOMSigFlg Start -->
		<el-row :gutter="30">
			<el-col :span="8">
				<sf-group-wrapper class="checkbox-form" :label="getMessage_('SWCC000799')" labelPosition="left" :gutter="30" :labelSpan="20">
					<el-checkbox :value="selectedRow.womSigYn === 'Y'" @change="value => onChange({ key: 'womSigYn', value: value ? 'Y' : 'N' })" />
				</sf-group-wrapper>
			</el-col>
		</el-row>
		<!-- WOMSigFlg End -->

		<template v-slot:footer>
			<sf-button
				v-if="isButton_(scrId, 'CD')"
				v-show="disabled"
				line
				color="error"
				:onClick="
					() =>
						$sf_showMessage({
							type: 'confirm',
							icon: 'confirm',
							message: getMessage_('SWCC000554'),
							buttons: [{ title: getMessage_('SWCC000280'), clickFn: removeProgram }]
						})
				"
				>{{ getMessage_('SWCC000280') }}</sf-button
			>
			<sf-button line :onClick="closeModal">{{ getMessage_('SWCC000243') }}</sf-button>
			<sf-button
				v-if="isButton_(scrId, 'AD')"
				v-show="!disabled"
				:onClick="
					() =>
						$sf_showMessage({
							type: 'confirm',
							icon: 'confirm',
							message: getMessage_('SWCC000555'),
							buttons: [{ title: getMessage_('SWCC000245'), clickFn: registerProgram }]
						})
				"
				>{{ getMessage_('SWCC000245') }}</sf-button
			>
			<sf-button
				v-if="isButton_(scrId, 'AD')"
				v-show="disabled"
				:onClick="
					() =>
						$sf_showMessage({
							type: 'confirm',
							icon: 'confirm',
							message: getMessage_('SWCC000553'),
							buttons: [{ title: getMessage_('SWCC000279'), clickFn: modifyProgram }]
						})
				"
				>{{ getMessage_('SWCC000279') }}</sf-button
			>
		</template>
	</sf-modal-layout>
</template>

<script>
import moment from 'moment';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/ProgramRegistration/store/helpers';
import * as yup from 'yup';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	created() {
		this.$sf_toggleLoading(true);
		this.fetchLines_({ plantCd: this.user.plantCd })
			.then(() => this.fetchMainFlgs_({ plantCd: this.user.plantCd }))
			.then(() => this.fetchExeEnvs_({ plantCd: this.user.plantCd }))
			.finally(() => this.$sf_toggleLoading(false));
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		closeModal() {
			this.DEFAULT_ASSIGN({
				key: 'popupParams',
				value: {
					type: '',
					show: false,
					selectedRow: {}
				}
			});
		},
		onChange({ key, value }) {
			this.DEFAULT_ASSIGN({
				key: 'popupParams',
				value: {
					...this.popupParams,
					selectedRow: {
						...this.selectedRow,
						[key]: value
					}
				}
			});
		},
		registerProgram() {
			try {
				this.schema.validateSync(this.selectedRow);

				this.$sf_toggleLoading(true);
				this.createProgram_({
					program: {
						...this.selectedRow,
						regDate: moment().format('YYYYMMDD'),
						regTime: moment().format('HHmmss')
					}
				})
					.then(header => {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					})
					.catch(error => {
						this.$sf_toast({ type: 'error', message: error.message });
					})
					.then(() => this.fetchPrograms_({ plantCd: this.user.plantCd, urlSearchParams: this.urlSearchParams_ }))
					.then(this.closeModal)
					.finally(() => this.$sf_toggleLoading(false));
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},
		modifyProgram() {
			try {
				this.schema.validateSync(this.selectedRow);

				this.$sf_toggleLoading(true);
				this.updateProgram_({ program: this.selectedRow })
					.then(header => {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					})
					.catch(error => {
						this.$sf_toast({ type: 'error', message: error.message });
					})
					.then(() => this.fetchPrograms_({ plantCd: this.user.plantCd, urlSearchParams: this.urlSearchParams_ }))
					.then(this.closeModal)
					.finally(() => this.$sf_toggleLoading(false));
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},
		removeProgram() {
			try {
				this.schema.validateSync(this.selectedRow);

				this.$sf_toggleLoading(true);
				this.deleteProgram_({ program: this.selectedRow })
					.then(header => {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					})
					.catch(error => {
						this.$sf_toast({ type: 'error', message: error.message });
					})
					.then(() => this.fetchPrograms_({ plantCd: this.user.plantCd, urlSearchParams: this.urlSearchParams_ }))
					.then(this.closeModal)
					.finally(() => this.$sf_toggleLoading(false));
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		selectedRow() {
			const { selectedRow } = this.popupParams;
			return selectedRow;
		},
		disabled() {
			const { type } = this.popupParams;
			return type.includes('update');
		},
		schema() {
			return yup.object().shape({
				pgmId: yup.string().nullable().required(this.getMessage_('SWCC000498')),
				shopCd: yup.string().nullable().required(this.getMessage_('SWCC000499')),
				lineCd: yup.string().nullable().required(this.getMessage_('SWCC000497')),
				pgmName: yup
					.string()
					.nullable()
					.max(
						100,
						this.$sf_formatString(this.getMessage_('SWCC000177') /**{0}은 최대 {1} 자리까지 입력 가능합니다. */, [
							this.getMessage_('SWCC000256'),
							100
						])
					),
				pgmUrlL: yup
					.string()
					.nullable()
					.max(
						500,
						this.$sf_formatString(this.getMessage_('SWCC000177') /**{0}은 최대 {1} 자리까지 입력 가능합니다. */, [
							this.getMessage_('SWCC000945'),
							500
						])
					),
				exeFile: yup
					.string()
					.nullable()
					.max(
						20,
						this.$sf_formatString(this.getMessage_('SWCC000177') /**{0}은 최대 {1} 자리까지 입력 가능합니다. */, [
							this.getMessage_('SWCC000260'),
							20
						])
					),
				exePath: yup
					.string()
					.nullable()
					.max(
						100,
						this.$sf_formatString(this.getMessage_('SWCC000177') /**{0}은 최대 {1} 자리까지 입력 가능합니다. */, [
							this.getMessage_('SWCC000261'),
							100
						])
					),
				workPath: yup
					.string()
					.nullable()
					.max(
						100,
						this.$sf_formatString(this.getMessage_('SWCC000177') /**{0}은 최대 {1} 자리까지 입력 가능합니다. */, [
							this.getMessage_('SWCC000262'),
							100
						])
					),
				svrIp: yup
					.string()
					.nullable()
					.max(
						20,
						this.$sf_formatString(this.getMessage_('SWCC000177') /**{0}은 최대 {1} 자리까지 입력 가능합니다. */, [
							this.getMessage_('SWCC000265'),
							20
						])
					),
				svrPort: yup
					.number()
					.typeError(this.$sf_formatString(this.getMessage_('SWCC000895'), [this.getMessage_('SWCC000266')]))
					.nullable()
					.max(
						5,
						this.$sf_formatString(this.getMessage_('SWCC000177') /**{0}은 최대 {1} 자리까지 입력 가능합니다. */, [
							this.getMessage_('SWCC000266'),
							5
						])
					),
				failOverIp: yup
					.string()
					.nullable()
					.max(
						30,
						this.$sf_formatString(this.getMessage_('SWCC000177') /**{0}은 최대 {1} 자리까지 입력 가능합니다. */, [
							this.getMessage_('SWCC000267'),
							30
						])
					),
				failOverPort: yup
					.number()
					.typeError(this.$sf_formatString(this.getMessage_('SWCC000895'), [this.getMessage_('SWCC000268')]))
					.nullable(),
				scrOffAddr: yup
					.string()
					.nullable()
					.max(
						20,
						this.$sf_formatString(this.getMessage_('SWCC000177') /**{0}은 최대 {1} 자리까지 입력 가능합니다. */, [
							this.getMessage_('SWCC000270'),
							20
						])
					),
				scrOnAddr: yup
					.string()
					.nullable()
					.max(
						20,
						this.$sf_formatString(this.getMessage_('SWCC000177') /**{0}은 최대 {1} 자리까지 입력 가능합니다. */, [
							this.getMessage_('SWCC000271'),
							20
						])
					)
			});
		}
	}
};
</script>

<style lang="scss">
.program-registration {
	.contour {
		width: 100%;
		height: 38px;
		background-color: #dedede;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #111111;
		font-size: 14px;
		font-family: HyundaiSansHead;
		font-weight: 500;
	}

	// TODO:
	.checkbox-form {
		.el-row {
			.el-col-24 {
				display: flex;
				align-items: center;
				padding-left: 0px !important;
			}
		}
	}
}
</style>
